module.exports = __webpack_public_path__ + "img/最新资讯.fc2ce9fa.png";